"use strict";

exports.__esModule = true;
exports.SingleDeviceGridFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Core = require("../../Core");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _DeviceSelector = require("../../Device/DeviceSelector");
var _Grid = require("../Grid");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SingleDeviceGridFields = exports.SingleDeviceGridFields = function SingleDeviceGridFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var allDevices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  allDevices = allDevices.filter(function (d) {
    return d.enabled;
  });
  var selectedDevice = allDevices.find(function (d) {
    return d.uuid === element.props.device;
  });
  (0, _react.useEffect)(function () {
    if (!selectedDevice) {
      elementEditor.setProp(path, "device", allDevices[0].uuid);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
    level: 5,
    ellipsize: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "SingleDeviceSelector.headingLabel",
    defaultMessage: "Select Device"
  })), /*#__PURE__*/_react["default"].createElement(_DeviceSelector.DeviceSelector, {
    items: allDevices,
    getKey: function getKey(device) {
      return device.uuid;
    },
    onSelect: function onSelect(selection) {
      elementEditor.setProp(path, "device", selection[0].uuid);
    },
    selected: selectedDevice ? [selectedDevice] : [],
    itemPredicate: function itemPredicate(query, device) {
      return new RegExp((query || "").toLowerCase()).test(device.name.toLowerCase());
    },
    width: 320,
    renderItemText: function renderItemText(device) {
      return device.name;
    }
  }), /*#__PURE__*/_react["default"].createElement(_Grid.GridFields, props), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementActionControlGroup, {
    controlPaths: {
      onClickAction: path
    },
    elementEditor: elementEditor
  }));
};